import { Component, OnInit } from '@angular/core';
import { Years } from 'src/app/models/years';
import { DataService } from 'src/app/shared/data/data.service';

@Component({
  selector: 'app-years',
  templateUrl: './years.component.html',
  styleUrls: ['./years.component.css']
})
export class YearsComponent implements OnInit {

  years: Years[];
  selectedValue: number;
  constructor(private dataService: DataService) {
  }

  ngOnInit() {
    this.getYears();
  }

  getYears(): void {
    this.dataService.getYears().subscribe((years => this.years = years) );
  }

}
